module.exports = __webpack_public_path__ + "static/station-f-logo-0eff49934cd598d202bbd70749277351.png";